export default __webpack_public_path__ + "static/media/icon_email_active.7aa9c751.svg";